import { Enums } from "../../thor.enums";
import { onlineT } from "../../typings/online";
import { paymentT } from "../../typings/payment";
import { setPaymentsDeposit } from "../../utils/payment";

export class LastBidderToolbarController {
    public static $inject: string[] = ["localeNumber", "paymentService"];

    // binded
    public user: onlineT.LastBidder;
    public containerEndDate: string;
    public containerId: number;
    public contractId: number;
    public getItems: Function;
    public payments: paymentT.Payment[];
    public paymentStatus: onlineT.past.ItemStatus;
    public saleCurrency: Enums.Currency;
    public saleDepositAmount: number;
    public salePaymentDeposit: paymentT.Payment[];

    public depositStateLabel;
    public paymentsDepositAmount: number;

    constructor(private localeNumber, public paymentService) {}

    public $onInit() {
        const paymentsDeposit = setPaymentsDeposit(this.user.user_id, this.payments, this.salePaymentDeposit);
        this.depositStateLabel = this.paymentService.getDepositStateLabel(paymentsDeposit);
        this.paymentsDepositAmount = this.localeNumber.sumNbrs(paymentsDeposit.map(p => Number(p.amount)));
    }
}
